import { render, staticRenderFns } from "./MerchantIntention.vue?vue&type=template&id=235ebe42&scoped=true&"
import script from "./MerchantIntention.vue?vue&type=script&lang=js&"
export * from "./MerchantIntention.vue?vue&type=script&lang=js&"
import style0 from "./MerchantIntention.vue?vue&type=style&index=0&id=235ebe42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ebe42",
  null
  
)

export default component.exports